
import angular from "angular";
import DependencyListBuilder from "../../../utility/DependencyListBuilder";

import TrackingEventReportFactory from "./TrackingEventReportFactory";
import TrackingEventFactory from "./TrackingEventFactory";

const trackingEventFactoriesModuleDependencies = DependencyListBuilder([
    TrackingEventFactory.dependencies,
    TrackingEventReportFactory.dependencies
]);

export default angular
    .module(
        "trackerbase-app.models.factories.tracking-event-factories",
        trackingEventFactoriesModuleDependencies
    )
    .service("TrackingEventReportFactory", TrackingEventReportFactory) //injector list in $inject static
    .service("TrackingEventFactory", TrackingEventFactory) //injector list in $inject static
    .name;



//////////////////
// WEBPACK FOOTER
// ./src/models/factories/tracking-event-factories/index.js
// module id = e2go
// module chunks = 1